<template>
  <div>
    <h4 class="mb-4 text-utel"><strong>Listado de colaboradores</strong></h4>
    
    <v-data-table
      :headers="headers" 
      :items="students" 
      item-key="id" 
      :page="currentPage"
      :items-per-page="itemsPerPage" 
      class="elevation-1 table text-center align-middle small" 
      :loading="loading"
      loading-text="Cargando..." 
      mobile-breakpoint="0" 
      :header-props="{ sortIcon: 'fa-solid fa-up-down' }"
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr class="text-center">
          <td>{{ item.id }}</td>
          <td>{{ item.firstname }} {{ item.lastname }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.statistics?.registered_routes || 0 }}</td>
          <td>{{ item.statistics?.routes_completed || 0 }}</td>
          <td>{{ item.statistics?.insignia || 0 }}</td>
          <td>
            <div class="fw-bold text-center small" style="width: 80px">
              {{ item.created_at_convert || "" }}
            </div>
          </td>
          <td>
            <button 
              type="button" 
              class="btn bg-utel-v2-secondary p-2 m-2 px-3 rounded-pill text-primary me-2" 
              title="Ver detalles" 
              @click="$emit('edit-student', item)"
            >
              <i class="fa-solid fa-eye"></i>
            </button>
          </td>
        </tr>
      </template>
    </v-data-table>
    
    <StudentPagination 
      :current-page="currentPage"
      :page-count="pageCount"
      @page-change="$emit('page-change', $event)"
    />
  </div>
</template>

<script>
import StudentPagination from './StudentPagination.vue'

export default {
  name: 'StudentTable',
  
  components: {
    StudentPagination
  },
  
  props: {
    students: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    pageCount: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 10 }
  },
  
  emits: ['edit-student', 'page-change'],
  
  computed: {
    headers() {
      return [
        { text: "#", value: "id", align: 'center' },
        { text: "Nombre", value: "firstname", align: 'center' },
        { text: "Correo", value: "email", align: 'center' },
        { text: "Rutas Inscritas", value: "statistics.registered_routes", align: 'center' },
        { text: "Rutas Finalizadas", value: "statistics.routes_completed", align: 'center' },
        { text: "Insignias Obtenidas", value: "statistics.insignia", align: 'center' },
        { text: "Registrado desde", value: "created_at_convert", align: 'center' },
        { text: "Opciones", value: "actions", sortable: false }
      ]
    }
  }
}
</script>

<style scoped>
.text-utel {
  color: #1A0054;
}
</style>